import { RouterContext } from 'mobx-state-router'
import './App.css'
import { RootStoreContext } from './context/RootStoreContext'
import { initApp } from './initApp'
import Start from './components/Start'
import useMediaQuery from '@mui/material/useMediaQuery';
import { useEffect } from 'react'

const rootStore = initApp()

export default function App() {

    const { routerStore } = rootStore;
    const portrait = useMediaQuery("(orientation: portrait)");
    const mobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
    
    useEffect(() => {
        const root = document.getElementById('root')!;

        if (mobile && !root.classList.contains('mobile')) {
            root.classList.add('mobile');
        } else if (!mobile) {
            root.classList.remove('mobile');
        }
        if (portrait && !root.classList.contains('portrait')) {
            root.classList.add('portrait');
        } else if (!portrait) {
            root.classList.remove('portrait');
        }
        
    }, [mobile, portrait]);

    return (
        <RootStoreContext.Provider value={rootStore}>
            <RouterContext.Provider value={routerStore}>                
                <Start />
            </RouterContext.Provider>
        </RootStoreContext.Provider>
    )
}